import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { UserRole } from '../../shared/interfaces/user.interface'

export const roleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  const user = authService.currentUser()
  if (!user) {
    return router.createUrlTree(['/auth/login'])
  }

  const requiredRoles = route.data['roles'] as UserRole[]
  const requiredRole = route.data['role'] as UserRole

  let hasPermission = false

  if (requiredRoles && requiredRoles.length > 0) {
    hasPermission = authService.hasAnyRole(requiredRoles)
  } else if (requiredRole) {
    hasPermission = authService.canAccess(requiredRole)
  } else {
    hasPermission = true
  }

  if (!hasPermission) {
    return router.createUrlTree(['/unauthorized'])
  }

  return true
}
